<template>
    <b-container fluid>
      <b-row>
        <b-container>
          <b-overlay :show="searchIsRunning" rounded="sm">
            <SearchForm
              :params="model.params"
              :key="'searchFormFor' + model.params.packageType"
              @search="onSearch"
          />
          </b-overlay>
          <template v-if="!searchIsRunning">
            <b-card class="bg-light p-2" no-body="">
              <b-row class="align-items-center">
                <b-col md="7">
                  <SearchResultsSummary :params="model.params" results="model.results"/>
                </b-col>
                <b-col md="5">
                  <SortFields
                  @sort="onSort"
                  @pagination="onPaginate"/>
                </b-col>
              </b-row>
            </b-card>
            <template v-if="model.results.length">
              <b-container class="content mt-3">
                <HotelResult
                  v-for="(result,resultIndex) in paginatedResults"
                  :result="result"
                  :params="model.params"
                  :key="'result' + resultIndex"
                  :selected="isSelected(result)"
                  :expanded="resultIndex === 0"
                  :displayedMeal="result.packages[0].categories[0].meals[0]"
                  @info="onInfo([result])"
                  @toggle="onToggle(result)"
                  >
                    <PackageResult
                      v-for="(pack, packIndex) in result.packages"
                      :pack="pack"
                      :resultIndex="resultIndex"
                      :currency="model.params.currency"
                      :key="'pack' + packIndex"
                      @book="onBook({ resultId: result.id, packageId: pack.id, ...$event })"
                      @priceDetails="onPriceDetails({ result, pack, ...$event })"
                      ></PackageResult>
                </HotelResult>
              </b-container>
            </template>
          </template>
        </b-container>
      </b-row>
      <!-- Modals -->
        <SelectedResults
          :results="selectedResults"
          v-show="selectedResults.length"
          @hide="onHideSelected()"
          @info="onInfoSelected()"
          />
        <b-modal v-model="modal" :title="$gettext('Modal Info')" size="xl" hide-header hide-footer>
          <div id="printArea">
            <ModalHeader @print="onPrint()" @download="onDownload()" @closeModal="onModalClose" />
            <SearchParamsSummary :params="model.params"/>
            <b-row v-for="result in infoResults" :key="'detailedInfo' + result.id" class="p-4">
              <DetailedInfo
                :result="result"
                :currency="model.params.currency"
              ></DetailedInfo>
            </b-row>
          </div>
          <ModalFooter @closeModal="onModalClose" />
        </b-modal>

        <b-modal v-model="priceDetailsModal" :title="$gettext('Price Details')" size="lg" hide-header hide-footer>
          <SimpleModalHeader @closeModal="closePriceDetailsModal" />
          <PriceDetails
            :title="priceDetailsParams.title"
            :meal="priceDetailsParams.meal"
            :discounts="priceDetailsParams.discounts"
            :paymentSchedule="priceDetailsParams.paymentSchedule"
          />
          <ModalFooter @closeModal="closePriceDetailsModal" />
        </b-modal>
    </b-container>
</template>

<script>
import model from './services/model'
import viewMixin from '../shared/mixins/search_views'
import SearchForm from './components/search_form'
import { paymentSchedule } from 'b2b-common/services/api/package'
import SortFields from '@/app/private/shared/components/sort_fields'
import SearchResultsSummary from './components/search_results_summary'
import SearchParamsSummary from './components/search_params_summary'
import HotelResult from '@/app/private/shared/components/hotel_result'
import PackageResult from './components/package_result'
import SelectedResults from '@/app/private/shared/components/selected_results'
import ModalFooter from '@/app/private/shared/components/modal_footer'
import ModalHeader from '@/app/private/shared/components/modal_header'
import SimpleModalHeader from '@/app/private/shared/components/simple_modal_header'
import PriceDetails from '@/app/private/shared/components/price_details'
import DetailedInfo from './components/detailed_info'

export default {
  components: {
    SearchForm,
    SortFields,
    SearchResultsSummary,
    HotelResult,
    PackageResult,
    SelectedResults,
    ModalFooter,
    ModalHeader,
    SimpleModalHeader,
    PriceDetails,
    DetailedInfo,
    SearchParamsSummary
  },
  mixins: [viewMixin],
  data () {
    return {
      model,
      priceDetailsParams: {
        meal: null,
        title: null,
        discounts: [],
        paymentSchedule: []
      }
    }
  },
  methods: {
    onBook ({ resultId, packageId, categoryId, mealIndex }) {
      let pType = this.model.params.packageType
      pType = pType[0].toUpperCase() + pType.slice(1)
      const route = {
        name: 'Private/' + pType + '/Book',
        params: {
          Result: resultId,
          Package: packageId,
          Category: categoryId,
          Meal: mealIndex
        }
      }
      this.$router.push(route)
    },
    async onPriceDetails ({ result, pack, category, meal }) {
      this.priceDetailsParams.title = pack.name
      this.priceDetailsParams.meal = meal
      this.priceDetailsParams.discounts = []
      if (Array.isArray(category.discounts)) this.priceDetailsParams.discounts = this.priceDetailsParams.discounts.concat(category.discounts)
      if (Array.isArray(pack.discounts)) this.priceDetailsParams.discounts = this.priceDetailsParams.discounts.concat(pack.discounts)
      this.priceDetailsParams.paymentSchedule = await paymentSchedule({
        packageType: this.model.params.packageType,
        category: category.id,
        meal: meal.id
      })
      this.priceDetailsModal = true
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
